export default "__VITE_ASSET__3fe97eff__"